'use client';
import React from 'react';
import FaqCategoryTabs from './Sections/FaqCategoryTabs';
import { NextUI } from '@/components/NextUI';
import { useAppDispatch } from '@/hooks/redux';
import { showModal } from '@/store/slices/modalSlice';
import { ContactCategoryEnum } from '@/features/contact/enums/contactCategory';
import { useTranslations } from 'next-intl';

const FaqCategoryDetail = () => {
  const dispatch = useAppDispatch();
  const t = useTranslations();

  const openContactModal = (option: ContactCategoryEnum) => {
    dispatch(
      showModal({
        modalKey: 'Contact',
        modalData: {
          defaultOption: option,
        },
      })
    );
  };

  return (
    <div>
      <FaqCategoryTabs />

      <div className="mt-12">
        <p className="body-normal text-gray-medium text-center">
          {t('faq.faq_page.could_not_found')}
        </p>

        <div className="mt-8 flex gap-5 justify-center">
          <NextUI.Button
            className="min-w-0 max-xxs:!text-[13px] max-xxs:!h-10 max-xxs:!px-[10px]"
            onClick={() => openContactModal(ContactCategoryEnum.REPORT)}
          >
            {t('faq.faq_page.write_a_report')}
          </NextUI.Button>

          <NextUI.Button
            className="min-w-0 max-xxs:!text-[13px] max-xxs:!h-10 max-xxs:!px-[10px]"
            onClick={() => openContactModal(ContactCategoryEnum.SUGGEST)}
          >
            {t('faq.faq_page.suggest_feature')}
          </NextUI.Button>
        </div>
      </div>
    </div>
  );
};

export default FaqCategoryDetail;
